import Header from "./Header";


const AboutPage = () => {

    return (
        <>
            <div className="gradientBanner"></div>
            <div className="container">
                <Header />
                <div className="card about">
                    <h2 id="about">About</h2>
                    <p>Unfold is a lightweight, domain-specific language for querying crypto wallets. It currently supports various operations, such as checking the ETH, ERC20, or ERC721 balance, on a single wallet address. </p>
                    <p>The primary benefit of Unfold is its simplicity in usage. You can learn the entire grammar in &lt; 5 minutes, making it a perfect low-code environment for tokengating your storefront or community. Moreover, every runtime is sandboxed and isolated from the rest of the environment. This prevents malicious users from injecting Javascript into your websites.</p>
                    <h2 id="under-the-hood">Under the Hood</h2>
                    <p>Every time any Unfold code is written, a separate runtime instance needs to be created to execute the code. </p>
                    <p>To maintain generalizability to other L1/L2 chains, Unfold runtimes expect two inputs: the written code and a wallet context. Wallet contexts are responsible for providing methods and attributes that interact with the chain, such as <code>address</code>, <code>queryNativeToken()</code>, <code>queryToken(tokenType, tokenAddress)</code>, and <code>setChain(chainId)</code>. </p>
                    <p>The lexing/parsing of Unfold is handled by <a href="https://nearley.js.org/docs/index">nearleyjs</a>, which returns an abstract syntax tree in JSON. This tree is passed off to simple interpreter written in vanilla Javascript. </p>
                    <h2 id="writing-scripts">Writing Scripts</h2>
                    <p>Every Unfold script is composed of statements. The Unfold runtime expects at most one statement per line. Unfold supports the usual comparators and conditional operations, as well as boolean values. </p>
                    <p>The syntax for an conditional statement is as follows.</p>
                    <pre>
                        <b>if</b> condition <b>then</b> directive
                    </pre>
                    or
                    <pre>
                        <b>if</b> condition <b>then</b> directive  <b>else</b> directive
                    </pre>

                    <p>A condition includes all of the usual comparators, logical symbols, and boolean values. Conditions can compare numbers (i.e. amount of USDC in a wallet) or addresses (i.e. for whitelisting).</p>
                    <p>A directive can be a return statement, a token assignment, a chain change, or another conditional statement. </p>
                    <p>The only type of variable in Unfold is a token. A token can be defined as follows.</p>
                    <pre>
                        <b>Token</b> <i>TokenName</i> <b>=</b> <i>TokenObject</i>
                    </pre>

                    <p><i>TokenName</i> can be any string. This identifier is stored a global state that can be reused by future statements. </p>
                    <p><i>TokenObject</i> can be created by either specifying ERC20 or ERC721 with a contract address. </p>
                    <pre>
                        <b>Token</b> <i>usdc</i> <b>=</b> <i>ERC20(0xA0b...)</i>
                    </pre>
                    <pre>
                        <b>Token</b> <i>bayc</i> <b>=</b> <i>ERC721(0xBC4...)</i>
                    </pre>

                    <p>There is also a special TokenObject <code>ETH</code> that queries the amount of Ether in a given wallet address. You can check how much of a token the current wallet has by using <code>$.balanceOf(<i>TokenName</i>)</code>. You can get the address of the current wallet with <code>$.address</code>, which can be used for whitelisting. </p>
                    <p>Any condition or value can be returned from the Unfold runtime through the <code>return</code> command.</p>
                    <p>Comments are prefaced with a pound symbol <code>#</code>. A comment must occupy its own line with no other code.</p>
                    <h3 id="how-can-i-use-this-in-my-project-">How can I use this in my project?</h3>
                    <p>It's currently open source! Check out the <a href="https://github.com/varunshenoy/unfold-lang">GitHub repo</a>.</p>

                </div>
            </div>
            <div className="gradientBanner"></div>
        </>
    );
}

export default AboutPage;